import * as React from "react";
const SvgFiRrPartyHorn = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-party-horn_svg__a)">
      <path
        fill="#062147"
        d="M16.95 16.702a2.7 2.7 0 0 0-.741-2.431l-6.48-6.479a2.699 2.699 0 0 0-4.401.863L.18 20.881a2.24 2.24 0 0 0 .481 2.458 2.24 2.24 0 0 0 2.46.481l12.227-5.147a2.7 2.7 0 0 0 1.603-1.971zM2.343 21.976a.23.23 0 0 1-.268-.052.226.226 0 0 1-.052-.269l3.472-8.247 5.097 5.095zm12.645-5.659a.7.7 0 0 1-.418.512l-1.989.837-6.248-6.247.838-1.99A.69.69 0 0 1 7.821 9c.136 0 .326.037.494.205l6.48 6.479a.7.7 0 0 1 .193.633M13.725.377A1 1 0 0 1 15.12.215c.082.066 2.05 1.651 1.877 4.349-.067 1.057-.472 2.079-1.202 3.041a1 1 0 0 1-1.4.193 1 1 0 0 1-.193-1.401c.489-.643.757-1.302.799-1.959.103-1.631-1.078-2.615-1.129-2.656a1.003 1.003 0 0 1-.15-1.403zm9.853 13.44a1 1 0 0 1-1.386-.23c-.03-.039-.46-.587-1.19-.587-.343 0-.647.098-.903.291a1 1 0 1 1-1.206-1.595 3.47 3.47 0 0 1 2.108-.695c1.432 0 2.444.895 2.817 1.424.319.451.21 1.075-.24 1.394zM21.002 1.5a1.5 1.5 0 1 1 3 .001 1.5 1.5 0 0 1-3-.001m-2 5a1.5 1.5 0 1 1 3 .001 1.5 1.5 0 0 1-3-.001M8 2.5a1.5 1.5 0 1 1 3.002.001A1.5 1.5 0 0 1 8 2.5m15 16a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 .001M1 3.5a1.5 1.5 0 1 1 3.002.001A1.5 1.5 0 0 1 1 3.5m17 19a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 .001"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-party-horn_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPartyHorn;
